import { useSelector } from 'react-redux';
import Yetkisiz from '../pages/ErrorPages/Yetkisiz';


const RoleRoute = ({ children, roles }) => {
    const _roles = useSelector((state)=>state.auth.userRole)
    let checking = roles.some((role) => _roles?.includes(role))
    if (!checking) {
        return (<Yetkisiz/>)
    } else {
        return children
    }
}

export default RoleRoute;
